<template>
  <div class="set-page-con">
    <div class="option-div">
      <el-form ref="form" inline :model="formInline" class="demo-form-inline" label-width="120px">
        <el-form-item>
          <div class="add" @click="openAdd">添加用户</div>
        </el-form-item>
        <el-form-item label="岗位">
          <el-select clearable :popper-append-to-body="false" popper-class="form-select-dropdown" v-model="formInline.job" class="form-select" placeholder="请选择">
            <el-option
              label="网格员"
              value="网格员">
            </el-option>
            <el-option
              label="巡查员"
              value="巡查员">
            </el-option>
            <el-option
              label="管理员"
              value="管理员">
            </el-option>
            <el-option
              label="一般人员"
              value="一般人员">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责区域">
          <el-select clearable :popper-append-to-body="false" popper-class="form-select-dropdown" v-model="formInline.areaName" class="form-select" placeholder="请选择">
            <el-option
              v-for="item in townshipList"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input clearable class="form-input" v-model="formInline.keyword" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="form-submit-btn" @click="search">查询</div>
        </el-form-item>
      </el-form>
    </div>
    <TableBox class="table-box">
      <table class="table-head" cellpadding="0" cellspacing="0">
        <tr ref="tableTr">
          <th class="label" v-for="item in headList" :key="item.label" :width="item.width">{{ item.label }}</th>
        </tr>
      </table>
      <div class="scroll-y">
        <table class="table-content" cellpadding="0" cellspacing="0">
          <tr v-for="(item, i) in tableData" :key="item.id">
            <td class="val" width="100">{{ i+1 }}</td>
            <td class="val" width="100">{{ item.name }}</td>
            <td class="val" width="100">{{ item.tel }}</td>
            <td class="val" width="100">{{ item.areaId | filterTown }}</td>
            <td class="val" width="100">{{ item.job }}</td>
            <td class="val font-00FFF6" width="100">
              <span @click="openEdit(item)" style="margin-right: 5px;">修改</span>
              <span @click="Delete(item)" class="font-FF1C2F" style="margin-left: 5px;">删除</span>
            </td>
          </tr>
        </table>
      </div>
    </TableBox>
    <div style="text-align: center;padding-top: 10px">
      <el-pagination
        class="ai-pagination"
        popper-class="ai-pagination"
        @current-change="handleCurrentChange"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <Dialog :show-foot="false" width="700px" v-if="showAddEdit" :background-image="require('./components/add-bg.png')"
            @close="showAddEdit = false" :title="addEditForm.id ? '编辑用户' : '新增用户'">
      <AddEdit :info="addEditForm" @close="showAddEdit = false" @confirm="confirm"></AddEdit>
    </Dialog>
  </div>
</template>

<script>
import TableBox from '@/components/ClipBox/index.vue'
import {addEmployee, deleteEmployee, editEmployee, getEmployeeListPage} from "../../../api/set";
import Dialog from "@/components/Dialog/index"
import AddEdit from "./components/AddEdit";
import { townshipList } from "../../../utils/common";
export default {
  name: "index",
  components: { TableBox, Dialog, AddEdit },
  data () {
    return {
      addEditForm: {},
      showAddEdit: false,
      total: 0,
      formInline: {
        page: 1,
        pageSize: 10
      },
      townshipList,
      headList: [
        {label: '序号', width: '100'},
        {label: '姓名', width: '100'},
        {label: '手机号/账号', width: '100'},
        {label: '负责区域', width: '100'},
        {label: '岗位', width: '100'},
        {label: '操作', width: '100'}
      ],
      tableData: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    openAdd () {
      this.addEditForm = {
        job: '网格员',
        tel: '',
        areaId: '001',
        authUseSys: ['pc'], // 'pc'=>'大屏(客户端)'，'weapp'=>'小程序'， 可以登录多个，用逗号隔开
        remark: '' // 备注（安次火点上用来记录村镇名称）
      }
      this.showAddEdit = true
    },
    openEdit (item) {
      this.addEditForm = item
      this.showAddEdit = true
    },
    Delete (item) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteEmployee({employeeId: item.employeesId}).then(res => {
          this.$message.success(res.msg)
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getList () {
      getEmployeeListPage(this.formInline).then(res => {
        this.tableData = res.data.list
        this.total = res.data.totalCount
      })
    },
    confirm (form) {
      form.authUseSys = form.authUseSys.toString()
      if (form.id) {
        editEmployee(form).then(() => {
          this.search()
        })
      } else {
        addEmployee(form).then(() => {
          this.search()
        })
      }
    },
    search () {
      this.formInline.page = 1
      this.getList()
    }
  },
  filters: {
    filterTown (val) {
      const list = townshipList.filter(x => {
        return x.value === val
      })
      return list[0] ? list[0].label : '-'
    }
  }
}
</script>

<style scoped lang="less">
  .set-page-con{
    width: 100%;
    height: 100%;
    .option-div{
      padding-top: 18px;
      .form-input {
        width: 200px;
        height: 40px;
      }
      .form-select{
        /deep/ .el-input__inner{
          height: 40px;
        }
      }

      &::v-deep {
        .el-form-item__label {
          padding-right: 28px;
          font-size: 20px;
          color: #ffffff;
        }
      }
      /deep/ .el-form-item{
        margin-bottom: 10px;
      }
      .add{
        width: 160px;
        height: 50px;
        background-size: 100% 100%;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        cursor: pointer;
        background-image: url("../img/add-btn.png");
        color: #00FFF6;
        margin-top: -6px;
      }
      .form-submit-btn {
        width: 150px;
        height: 50px;
        line-height: 50px;
        margin-top: -5px;
        margin-left: 25px;
        font-size: 17px;
        color: #00b2ff;
        letter-spacing: 12px;
        text-indent: 12px;
        text-align: center;
        background: url("~@/assets/img/settings/button-bg2.png") no-repeat
          center / 100% 100%;
        cursor: pointer;
      }
    }
    .table-box{
      height: calc(100% - 140px);
      .table-head {
        width: 100%;
        height: 50px;
        background-color: rgba(0, 255, 246, 0.3);

        th {
          padding: 0 10px;
          color: #00FFF6;
          font-size: 18px;
        }
      }

      .scroll-y {
        height: calc(100% - 50px);
        overflow-y: auto;
      }

      .table-content {
        width: 100%;
        text-align: center;
        table-layout: fixed;
        tr {
          height: 50px;
        }

        tr:nth-child(even) {
          background-color: rgba(0, 255, 246, 0.1);
        }

        td {
          padding: 0 10px;
          font-size: 16px;
          height: 50px;
          line-height: 50px;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //用省略号显示
          white-space:nowrap; //不换行
        }
      }
    }
  }
</style>
